import BaseService from './base'

export default class GenericSourceService extends BaseService {
  static resource() {
    return 'api/v1/external/genericSource'
  }
}
